import {useCallback} from 'react';
import {Area, AreaChart, CartesianGrid, ResponsiveContainer, XAxis} from 'recharts';
import styled from 'styled-components';
import {Flexbox} from '@/styled-components';
import {palette} from '@/styles';
import {ChartTitle} from '../../StyledComponents';
import {CHART_COLORS, EMPTY_ITEM_TYPES} from '../constants';
import {EmptyItem} from '../EmptyItem';

export interface IProps {
  type: string;
  data: number[];
  compareItemName: string;
  compareItemIndex: number;
  labels: string[];
}

export const SalesDayTimeSynchronizedAreaChart = ({
  type,
  data: rawdata,
  compareItemName,
  compareItemIndex,
  labels,
}: IProps) => {
  const getChartData = useCallback(() => {
    const chartData: Array<{name: string; value: number}> = rawdata.map(
      (item, index) => ({
        name: labels[index],
        value: Math.round(item * 10) / 10 || 0,
      })
    );

    return chartData;
  }, [labels, rawdata]);

  const chartData = getChartData();

  if (!chartData) {
    return null;
  }

  return (
    <Root>
      <Flexbox>
        <ChartTitle>{compareItemName}</ChartTitle>
      </Flexbox>
      {!!chartData?.length ? (
        <ChartWrapper>
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart
              data={chartData}
              syncId={type}
              margin={{
                top: 0,
                right: 10,
                left: 10,
                bottom: 0,
              }}
            >
              <CartesianGrid
                vertical={false}
                stroke={palette.gray100}
                strokeWidth={1}
              />
              <XAxis
                dataKey="name"
                interval={0}
                tick={{fontSize: 12, fill: palette.gray600}}
                tickLine={false}
              />
              <Area
                type="monotone"
                dataKey="value"
                stroke={CHART_COLORS[compareItemIndex]}
                fill={CHART_COLORS[compareItemIndex]}
              />
            </AreaChart>
          </ResponsiveContainer>
        </ChartWrapper>
      ) : (
        <EmptyItem type={EMPTY_ITEM_TYPES.Sales} />
      )}
    </Root>
  );
};

const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const ChartWrapper = styled.div`
  height: 98px;
`;
